<p-breadcrumb [model]="routePath"></p-breadcrumb>
<div appAccessProvider [accessCode]="{ menuCode: 'SPONSORS', pageCode: 'ALL', subPageCode: 'ADD' }">
  <app-module-header [label]="btnLabel" (onBtnClick)="onAddSponsor()" [showImportExportBtn]="showImportExportBtn" [moduleHeaderSecondaryBtnMenuItems]="moduleHeaderSecondaryBtnMenuItems" [showLastSync]="false"></app-module-header>
</div>
<div appAccessProvider [accessCode]="{ menuCode: 'SPONSORS', pageCode: 'ALL', subPageCode: 'LIST' }">
<p-tabView [(activeIndex)]="activeIndex" (onChange)="tabViewChange($event)" [scrollable]="true">
  <p-tabPanel>
    <ng-template pTemplate="header">
      <i class="{{miIcons.DASHBOARD_ACTIVITY_FEED}} inline-block wh-14 mr-2 relative"></i>
      <span [ngClass]="{'active-tab-label': activeIndex === 0, 'inactive-tab-label': activeIndex !== 0}" class="tab-label" translate>lbl_all</span>&nbsp;<span class="iconNumber text-color-secondary">({{totalRecords}})</span>
    </ng-template>
    <ng-template pTemplate="body">
      @if(data){

        <app-mi-table
          [collectionOfColumns]="allColumns"
          [attributeLabels]="filterAttributeLabels"
          [data]="tableData"
          entityName="sponsor"
          [isLoading]="isLoading"
          (onPageChange)="onPageChange($event)"
          (itemPerPageChange)="itemPerPageChange($event)"
          [totalRecords]="totalRecords"
          [itemsPerPage]="itemsPerPage"
          [message]="deleteSponsorMsg"
          [header]="deleteSponsorHeaderMsg"
          (onDelete)="onSponsorDelete($event)"
          (onBulkDataDeleteEvent)="onBulkDataDeleteEvent($event)"
          (onRowSelection)="onRowSelect($event)"
          [filterList]="filterList"
          (onValueChange)="onFilterValueChange($event)"
          [filterFields]="filterFieldsArray"
          [label]="btnLabel"
          (onBtnClick)="onAddSponsor()"
          [bulkUpdateLabel]="bulkUpdateLabel"
          [bulkDeleteLabel]="bulkDeleteLabel"
          [attributeData]="attributeData"
          (onBulkDataUpdateEvent)="onBulkDataUpdateEvent($event)"
          (onSearchValueChange)="onSearchValueChanges($event)"
          (onUpdate)="onUpdateSponsor($event)"
          [rowItems]="rowItems"
          [bulkSelectionsItems] = "bulkSelectionsItems"
          (setCurrentRowData)="setCurrentRowData($event)"
          [visiblePrintLabel]="visiblePrintLabel"
          [showBulkUpdateDialog]="showBulkUpdateDialog"
          (onToggleOverLay)="showBulkUpdateDialog = false; visiblePrintLabel = false"
          [visible]="visible"
          [bulkUpdateHeader]="bulkUpdateHeader"
          [reviewHeader]="reviewHeader"
          [btnUpdate]="btnUpdate"
          (onSortData)="onSortData($event)"
          [isEntity]="isEntity"
          >
        </app-mi-table>
      }
    </ng-template>
  </p-tabPanel>

</p-tabView>
</div>

<input hidden type="file" id="upload" (change)="onChange($event)" accept="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel" #uploader>